/* eslint-disable max-len */
import { TextInput } from '@mantine/core';
import { useIntl } from 'react-intl';

import sharedMessages from 'Components/utils/sharedMessages';
import { useTeamMemberContext } from 'Screens/Dashboard/Team/Components/TeamCellHandler/TeamInteractions/Interactions/Details/TeamMemberDetailsContext';

const TeamMemberNameInput = () => {
    const intl = useIntl();
    const { values } = useTeamMemberContext();
    const { name } = values;

    return (
        <TextInput
            id="name-input-in-team-member"
            label={intl.formatMessage(sharedMessages.nameAndSurname)}
            value={name}
            disabled
        />
    );
};

export default TeamMemberNameInput;
